import GlitchText from './GlitchText';
import './Loader.css';

/* ============================================================================
   Loader — the "no signal / tuning in" state.

   Used for every waiting moment in the app (SDK handshake, article fetch) so
   loading always looks like the same broken transmission rather than a generic
   spinner in three different places.
   ========================================================================== */

function Loader({ message = 'Tuning signal', hint = null }) {
  return (
    <div className="ui-loader">
      <div className="ui-loader__tube">
        <div className="ui-loader__bars">
          {/* SMPTE-ish colour bars, because of course. */}
          {['#f4f8ff', '#ffd23f', '#2ee9ff', '#7dff6b', '#ff3ad6', '#ff1f3d', '#123057'].map(
            (color) => (
              <span key={color} style={{ background: color }} />
            )
          )}
        </div>
        <div className="ui-loader__sweep" />
      </div>

      <GlitchText as="p" className="ui-loader__message" intensity="extreme" tone="red">
        {message}
      </GlitchText>

      <div className="ui-loader__dots">
        <span />
        <span />
        <span />
      </div>

      {hint && <p className="ui-loader__hint">{hint}</p>}
    </div>
  );
}

export default Loader;
